var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-array',{attrs:{"label":_vm.label,"value":_vm.parsed_value,"input-props":_vm.input_props},on:{"input":ev => _vm.$emit(`input`, Object.assign({},ev))}})
}
var staticRenderFns = []

export { render, staticRenderFns }